import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import get from 'lodash.get';
import { lowestQuoteReduce, getQuoteAmountByCurrency } from '../../helpers/shippingHelpers';

function ItemShipping({ currency, item }) {
    const filteredPreQuotes = get(item, 'shipmentQuotes', []).filter(quote => !quote.isLocalPickup);

    let shippingLabel;
    let shippingAmount;

    if (filteredPreQuotes.length === 0) {
        shippingLabel = (
            <FormattedMessage
                id="portfolio.listView.shipping_not_quoted"
                defaultMessage="Shipping not quoted"
            />
        );
    } else {
        const lowestQuote = filteredPreQuotes.reduce(lowestQuoteReduce);
        if (lowestQuote.isComplimentary) {
            shippingLabel = (
                <FormattedMessage
                    id="portfolio.listView.shipping_complimentary"
                    defaultMessage="Complimentary shipping available"
                />
            );
        } else {
            shippingLabel = (
                <FormattedMessage
                    id="portfolio.listView.shipping_starts"
                    defaultMessage="Shipping starts at"
                />
            );
            shippingAmount = getQuoteAmountByCurrency(lowestQuote, currency);
        }
    }

    let formattedShippingAmount;
    if (shippingAmount) {
        formattedShippingAmount = (
            <FormattedNumber value={shippingAmount} style="currency" currency={currency} />
        );
    }

    return (
        <div>
            {shippingLabel}
            {formattedShippingAmount ? ' ' : ''}
            {formattedShippingAmount}
        </div>
    );
}

ItemShipping.propTypes = {
    currency: PropTypes.string,
    item: PropTypes.object,
};

export default createFragmentContainer(ItemShipping, {
    item: graphql`
        fragment ItemShipping_item on Item {
            shipmentQuotes {
                isLocalPickup
                isComplimentary
                handlingTimeDisplay
                serviceMethod {
                    displayName
                    region {
                        regionName
                    }
                }
                totalAmount {
                    convertedAmountList {
                        currency
                        amount
                    }
                    amount
                }
            }
        }
    `,
});
